import React, { useState, useCallback } from 'react';
import { Route, Redirect, Switch, withRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import toast from '../toast';
import { css } from 'glamor';
import SidebarMenu from './SidebarMenu/SidebarMenu';
import Dashboard from './Dashboard/DashboardDefault/DashboardDefault';
import Analytics from './ConnectionsAnalytics/analytics';
import Account from './Account/Account';
import SocialMedia from './SocialMedia/SocialMedia';
import SocialPlatform from '../SocialPlatform/SocialPage.js';
import InstagramPage from '../Instagram';
import MediaComment from './Dashboard/mediaComment/MediaComment';
import PlayerStatus from './Dashboard/Video/Player/Player';
import './DashboardPage.css';

function DashboardPage({ history, location }) {
  const notifySuccess = useCallback((msg) => toast.success(msg), []);
  const notifyError   = useCallback((msg) => toast.error(msg), []);

  const isAuthenticated = () => !!localStorage.getItem('authToken') || true;

  const currentPath = location.pathname;

  if (isAuthenticated() && (currentPath === '/' || currentPath === '/dashboard')) {
    history.push('/dashboard/main');
  }

  if (!isAuthenticated()) {
    return <Redirect to="/" />;
  }

  const commonProps = { notifySuccess, notifyError };
  const isSocialPage = currentPath === '/dashboard/social/platform';

  return (
    <div className="rs-app">
      <div className={`rs-app-body${currentPath === '/dashboard/main' ? ' rs-has-player' : ''}`}>
        {/* Sidebar */}
        <SidebarMenu currentLocationPath={currentPath} />

        {/* Social platform — full width, no padding wrapper */}
        {isSocialPage && (
          <div className="rs-social-content">
            <Route exact path="/dashboard/social/platform" render={props => (
              <SocialPlatform {...props} {...commonProps} />
            )} />
          </div>
        )}

        {/* All other routes — inside padded main content */}
        {!isSocialPage && (
          <main className="rs-main-content">
            <Switch>
              <Route exact path="/dashboard/main" render={props => (
                <Dashboard {...props} {...commonProps} />
              )} />
              <Route exact path="/dashboard/account" render={props => (
                <Account {...props} {...commonProps} />
              )} />
              <Route exact path="/dashboard/socialMedia" render={props => (
                <SocialMedia {...props} {...commonProps} />
              )} />
              <Route exact path="/dashboard/comments" render={props => (
                <MediaComment {...props} {...commonProps} />
              )} />
              <Route exact path="/dashboard/social/statistics" render={props => (
                <Analytics {...props} {...commonProps} />
              )} />
              <Route exact path="/dashboard/instagram/rtmp" render={props => (
                <InstagramPage {...props} {...commonProps} />
              )} />
            </Switch>
          </main>
        )}

        {/* Right panel — only visible on the main dashboard */}
        {currentPath === '/dashboard/main' && (
          <aside className="rs-player-panel">
            <PlayerStatus />
          </aside>
        )}
      </div>

      {/* Footer */}
      <footer className="rs-footer">
        <div>
          <a href="https://relaystream.com.br/about.html" target="_blank">Quem somos</a>
          <a href="https://relaystream.com.br/politica.html" target="_blank">Privacidade</a>
          <a href="https://relaystream.com.br/privacy-facebook.html" target="_blank">Facebook-Privacidade</a>
          <a href="https://relaystream.com.br/termos.html" target="_blank">Termos e Condições</a>
          <a className="termsPage ml-2" href="/contact-us" target="_blank">Contate-Nos</a>
        </div>
        <span>Relay Stream</span>
      </footer>

      <ToastContainer
        className={{ textAlign: 'center' }}
        progressClassName={css({ background: '#1db954' })} />
    </div>
  );
}

export default withRouter(DashboardPage);



// WEBPACK FOOTER //
// ./src/components/DashboardPage/DashboardPage.js